<div class="flex flex-col gap-1">
  <span class="font-semibold text-default">{{ title }}</span>
  <span>{{ body }}</span>
</div>
